import { TPannellumConfig } from '../../types/panellum';

const basePath = 'https://static.treedis.com/projects/pisgat';

export const pannellumConfigPisgat: { [key: number]: TPannellumConfig } = {
  1: {
    type: 'multires',
    hfov: 100,
    pitch: -5,
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hotSpots: [
      // Building hotspots
      {
        pitch: 4.411464210733264,
        yaw: -29.456156355514402,
        type: 'info',
        createTooltipArgs: { title: '1', type: 'building' },
      },
      {
        pitch: 4.813810893770196,
        yaw: -15.010903349461394,
        type: 'info',
        createTooltipArgs: { title: '2', type: 'building' },
      },
      {
        pitch: 2.721636425064211,
        yaw: 2.131253061065498,
        type: 'info',
        createTooltipArgs: { title: '3', type: 'building' },
      },
      {
        pitch: 2.6018161147719194,
        yaw: 15.7379883007211,
        type: 'info',
        createTooltipArgs: { title: '4', type: 'building' },
      },
      // POI hotspots
      {
        pitch: 2,
        yaw: -71,
        type: 'info',
        createTooltipArgs: {
          title: 'פארק פסגת זאב',
          stem: 100,
          type: 'poi',
          cardDescription: 'פארק פסגת זאב',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 9, walk: 6, bicycle: 5 },
        },
      },
      {
        pitch: 0,
        yaw: -84,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון לב הפסגה',
          stem: 100,
          type: 'poi',
          cardDescription: 'קניון לב הפסגה',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 10, walk: 18, bicycle: 8 },
        },
      },
      {
        pitch: -21,
        yaw: -44,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת הקלה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת הקלה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 8, walk: 20, bicycle: 8 },
        },
      },
      // Scene hotspots
      {
        pitch: 7,
        yaw: -7.413068640259894,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene_2.webp`,
        },
      },
      {
        pitch: 5,
        yaw: -40.3901310350339,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 3',
          stem: 50,
          type: 'scene',
          sceneId: 3,
          imgSrc: `${basePath}/pano/tags/scene_3.webp`,
        },
      },
    ],
  },
  2: {
    type: 'multires',
    hfov: 110,
    pitch: -5,
    yaw: -10,
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hotSpots: [
      // Building hotspots
      {
        pitch: 9.511476158021681,
        yaw: 22.276504969310842,
        type: 'info',
        createTooltipArgs: { title: '1', type: 'building' },
      },
      {
        pitch: 10.415604609165346,
        yaw: 4.5255499167920075,
        type: 'info',
        createTooltipArgs: { title: '2', type: 'building' },
      },
      {
        pitch: 7.2856536813191095,
        yaw: -18.444873882808004,
        type: 'info',
        createTooltipArgs: { title: '3', type: 'building' },
      },
      {
        pitch: 6.743953646382024,
        yaw: -34.717470029065105,
        type: 'info',
        createTooltipArgs: { title: '4', type: 'building' },
      },
      // POI hotspots
      {
        pitch: -4,
        yaw: 67,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון לב הפסגה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קניון לב הפסגה',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 10, walk: 18, bicycle: 8 },
        },
      },
      {
        pitch: -3.9816727463836616,
        yaw: 74,
        type: 'info',
        createTooltipArgs: {
          title: 'פארק פסגת זאב',
          stem: 50,
          type: 'poi',
          cardDescription: 'פארק פסגת זאב',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 9, walk: 6, bicycle: 5 },
        },
      },
      {
        pitch: -15.9721370201101,
        yaw: 31.604163396132115,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת הקלה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת הקלה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 8, walk: 20, bicycle: 8 },
        },
      },

      {
        pitch: 5,
        yaw: 36,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 3',
          stem: 50,
          type: 'scene',
          sceneId: 3,
          imgSrc: `${basePath}/pano/tags/scene_3.webp`,
        },
      },
      {
        pitch: 8,
        yaw: -8,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene_1.webp`,
        },
      },
    ],
  },
  3: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/3`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hfov: 100,
    pitch: -5,
    yaw: -13,
    hotSpots: [
      // Building hotspots
      {
        pitch: 20.60380027737998,
        yaw: -30.25908203401108,
        type: 'info',
        createTooltipArgs: { title: '1', type: 'building' },
      },
      {
        pitch: 17.07176510391351,
        yaw: -16.99928985109821,
        type: 'info',
        createTooltipArgs: { title: '2', type: 'building' },
      },
      {
        pitch: 11.622921814801364,
        yaw: -9.47800367520501,
        type: 'info',
        createTooltipArgs: { title: '3', type: 'building' },
      },
      {
        pitch: 9.86480202467942,
        yaw: -5.681584132803312,
        type: 'info',
        createTooltipArgs: { title: '4', type: 'building' },
      },
      // POI hotspots
      {
        pitch: -46.136257339831396,
        yaw: -37.72052620366543,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת הקלה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת הקלה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 8, walk: 20, bicycle: 8 },
        },
      },
      {
        pitch: -8.685483167522266,
        yaw: -166.65456595305477,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון לב הפסגה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קניון לב הפסגה',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 10, walk: 18, bicycle: 8 },
        },
      },
      {
        pitch: -9.727555945910893,
        yaw: -148.52803822837154,
        type: 'info',
        createTooltipArgs: {
          title: 'פארק פסגת זאב',
          stem: 50,
          type: 'poi',
          cardDescription: 'פארק פסגת זאב',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 9, walk: 6, bicycle: 5 },
        },
      },
      {
        pitch: 13,
        yaw: -45,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene_2.webp`,
        },
      },
      {
        pitch: 15,
        yaw: -10.825492819205579,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene_1.webp`,
        },
      },
    ],
  },
};
